<!-- Lista de items con foto -->
<div class="row">
  <div *ngFor="let item of items" class="col-12">
    <!-- Item con foto -->
    <div class="meal" [ngStyle]="{'color': menu.colorText}" *ngIf="item.photo !== '' && !item.hiddenPhoto">
      <div class="row">
        <div class="col-9">
          <h5 class="meal-title font-weight-bold {{menu.fontHeader}}" [ngStyle]="{'color': menu.colorText}" translate="no">
            {{ item.name | firstuppercase }}
          </h5>
        </div>
        <div class="col-3">
          <div class="meal-actions justify-content-end p-0 {{menu.fontText}}"> <button class="comment {{menu.fontText}}" [ngStyle]="{'color': menu.colorText}"><span
                class="material-icons">
              </span> <span class="count mt-4" translate="no">{{ item.price | typeNumber: menu.units }}
              </span></button></div>
        </div>
      </div>
      <!-- Imagen del producto -->
      <div class="image-container" *ngIf="!item.hiddenPhoto">
        <img class="img-fluid" [defaultImage]="loadingImage" [lazyLoad]="item.photo" loading="lazy" [alt]="item.name" [id]="item.name">
      </div>
      <!-- Descripcion -->
      <ng-container [ngTemplateOutlet]="description" [ngTemplateOutletContext]="{item: item}"></ng-container>

    </div>
    <!-- Item sin foto -->
    <div class="meal" [ngStyle]="{'color': menu.colorText}" *ngIf="item.photo === '' || item.hiddenPhoto">
      <div class="row">
        <div class="col-9">
          <h5 class="meal-title font-weight-bold {{menu.fontHeader}}" [ngStyle]="{'color': menu.colorText}" translate="no">
            {{ item.name | firstuppercase }}
          </h5>
        </div>
        <div class="col-3">
          <div class="meal-actions justify-content-end p-0 {{menu.fontText}}"> <button class="comment {{menu.fontText}}" [ngStyle]="{'color': menu.colorText}"><span
                class="material-icons" *ngIf="item.price > 0">
              </span> <span class="count mt-4" translate="no">{{ item.price | typeNumber: menu.units }}
              </span></button></div>
        </div>
      </div>
      <!-- Descripcion -->
      <div class="row">
        <ng-container [ngTemplateOutlet]="description" [ngTemplateOutletContext]="{item: item}"></ng-container>
      </div>
    </div>
  </div>
</div>


<ng-template #description let-item="item">
  <!-- Label de recomendado -->
  <app-recommend *ngIf="item.home" [menu]="menu"></app-recommend>
  <!-- Descripcion del producto -->
  <div class="row">
    <!-- Descripcion en espanol -->
    <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'ES'" [ngStyle]="{'color': menu.colorText}" [innerHTML]="descriptionParser.getParsedDescription(item, 'ES')">
    </p>
    <!-- Descripcion en ingles -->
    <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'EN'" [ngStyle]="{'color': menu.colorText}" [innerHTML]="descriptionParser.getParsedDescription(item, 'EN')">
    </p>
  </div>
  <!-- Iconos sobre el porducto -->
  <div class="row mt-2">
    <div class="col">
      <app-type-product [menu]="menu" [item]="item"></app-type-product>
    </div>
  </div>
</ng-template>